import { render, staticRenderFns } from "./furtherWayReport.vue?vue&type=template&id=528bb00a&scoped=true"
import script from "./furtherWayReport.vue?vue&type=script&lang=js"
export * from "./furtherWayReport.vue?vue&type=script&lang=js"
import style0 from "./furtherWayReport.vue?vue&type=style&index=0&id=528bb00a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528bb00a",
  null
  
)

export default component.exports